var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3786 6.10276H3.09083L9.84689 0.473126C9.95493 0.382386 9.88934 0.213867 9.74658 0.213867H8.03923C7.96399 0.213867 7.89261 0.239793 7.83667 0.286089L0.546216 6.35831C0.479444 6.41387 0.425893 6.48256 0.389192 6.55972C0.35249 6.63688 0.333496 6.72071 0.333496 6.80553C0.333496 6.89036 0.35249 6.97419 0.389192 7.05135C0.425893 7.12851 0.479444 7.1972 0.546216 7.25275L7.87911 13.362C7.90805 13.3861 7.94277 13.399 7.97943 13.399H9.74465C9.88741 13.399 9.953 13.2287 9.84496 13.1398L3.09083 7.51016H14.3786C14.4635 7.51016 14.5329 7.4435 14.5329 7.36201V6.2509C14.5329 6.16942 14.4635 6.10276 14.3786 6.10276Z",
    fill: "#3879F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.8a8e9474a5c91a63234e6bb17c8b690b.svg";
export { ForwardRef as ReactComponent };